/* eslint-disable */
// 共通用メッセージ
export const common = {
  I: {
    '001':
      '選択された管理者は、ユーザに割り当てられています。削除すると割り当ても自動的に解除されます。',
    '002': '入力中のデータは消去されます。よろしいですか？',
    '003': '更新しました。',
    '004': '登録完了しました。',
    '005': '現在登録されているデータがありません。',
    '006': '※承認されたデータは編集ができなくなります。',
    '007': '承認',
    '008': '戻る',
    '009': '承認が完了しました。',
    '010': '承認完了',
    '011': '了解',
    '012': 'よく似た以下の会社がすでに登録されていますが、 登録を行いますか？',
    '013': 'CCUSに登録されている現場IDを入力してください',
    '014': 'CCUS通信中\nお待ちください',
    '015':
      'この現場をCCUSに新規登録します。\nすでにCCUSに登録済みの場合は「キャンセル」を押してください',
    '016': '※CCUSの現場情報はBuildeeからは更新できません',
    '017': '閉じる',
    '018': '削除',
    '019': 'コピーする',
    '020': '承認解除',
    '021': '解除',
    '022': '承認解除完了',
    '023': '更新完了しました。',
    '024': '※承認者が0人のデータは編集できるようになります。',
    '025': '編集画面を閉じる',
    '026': '消去',
    '027':
      '※いただいたお問い合わせに関してのお知らせは、Buildeeの画面上に表示されます。\n　弊社からの回答につきましては、通知一覧またはお問い合わせ一覧よりご確認ください。\n　メールでのご連絡は致しませんのであらかじめご了承ください。',
    '028':
      '※正確な対応のため、お問い合わせ内容にはできるかぎり詳細な情報（お使いいただいているブラウザのバージョンや、対象データの日付\n　情報など）をご記入いただきますよう、ご協力のほどお願い申し上げます。',
    '029': '編集画面を閉じる',
    '030': '消去',
    '031': 'この内容でお問い合わせをします。よろしいですか？',
    '032': 'お問い合わせ送信',
    '033': '未読通知はありません',
    '034':
      'お問い合わせの前に「マニュアル」やマニュアル内記載の「よくあるご質問」をあらかじめご確認いただきますようお願いいたします。',
    '035': '回答までの目安：半日〜２営業日程度',
    '036':
      '多数のお問い合わせが集中した場合、ご回答までにお時間を頂戴する事がございます。\nまたお問い合わせの内容によっては、ご回答に頂戴するお時間が、平均よりもかかる場合がございます。\nお急ぎでない場合にご利用ください。',
    '037':
      'お問い合わせの内容によっては、お調べのうえ折り返しご連絡させていただくことがございます。\nあらかじめご了承ください。',
    '038': 'マニュアルをご用意しております。お問い合わせの前に、ご確認ください。',
    '039':
      'お問い合わせ内容によっては、回答までにお時間を頂戴することがございます。\nあらかじめご了承ください。',
    '040': '試行期間中は、電話でのお問い合わせはお受けしておりません。',
    '041':
      '本サイトは『Buildee調整会議』の試行サイトのため、作成されたデータの引き継ぎはされません。\nまた、試行期間終了後は試行サイトにアクセスすることができないため、必要に応じてお問い合わせ内容や回答をお控えください。',
    '042': '試行期間中は、操作方法についてのお問い合わせのみお受けいたします。',
    '043':
      '※ お問い合わせの受付や回答は、Buildee上で通知されます。メールでのお知らせはありません。\n弊社からの回答はお問い合わせ一覧よりご確認ください。',
    '044':
      '※ お問い合わせ内容にはできるかぎり詳細な情報（お使いいただいているブラウザのバージョンや、対象データの日付情報など）を\nご記入いただきますようお願いいたします。',
    '045': '{0}しました。',
    '046': 'データがありません',
    '047': '帳票出力中です。しばらくお待ちください...',
    '048': '帳票出力が完了しました。',
    '049': '保存しました。',
    '050': '変更した内容は保存されません。編集画面を閉じてよろしいですか？',
    '051': 'ページの移動',
    '052': '変更した内容は保存されません。このページから移動してよろしいですか？',
    '053': '移動',
    '054': '確定',
    '055': '同意する',
    '056':
      '連携には、CCUSの事業者IDと管理者ID、パスワードが必要です。\n\nお手元に建設キャリアアップシステムの「事業者情報登録完了のお知らせ」をご用意いただくと、設定がスムーズに進みます。',
    '057': '変更する',
    '058':
      '支店を変更すると、選択したBuildee担当者とJV会社がクリアされます。\n変更してよろしいですか？',
    '080': '登録',
    '081': '送信',
    '082': '承認依頼する',
    '083':
      'ただいまCSVファイルを出力しています。 \nファイルの出力には少々お時間をいただく場合があります。\n出力が完了しましたら、メールにてご連絡いたします。 \nCSVダウンロードへ進み、データのダウンロードを行ってください。',
    '084':
      '現在、CSV出力オプションのご契約が無いため、CSV出力はご利用いただけません',
    '085': 'OK',
    '086':
      '連携には時間がかかります。しばらく時間をおいて、再度作業員一覧画面を開いてください。\n再度開くと最新の作業員情報が表示されます。',
    '087':
      '設定は支店内の全現場に反映されます。誤った内容を入力しないようご注意ください。この内容で更新してよろしいですか？',
    '088': '更新',
    '089': '通常モード表示、会議モード表示は最低1項目のチェックが必須です。',
    '201-01': 'JPEGファイルをアップロードして下さい。',
    '090': 'テキストを入力して検索',
    '091': '決定',
    '092': '表示項目をすべて選択',
    '093': '削除',
    '094': '申請を削除しますか？',
    '095': '申請取り消し',
    '096': '申請を取り消しますか？',
    '097': '取り消し',
    '098': '申請の重複',
    '099': 'この代行先に対する申請が既にあります。そちらの申請に移動しますか?',
    '100': '同意事項',
    '101':
      '申請することによって、リバスタへ申請依頼が送られます。この内容で申請してよろしいですか？',
    '102': '申請',
    'confirmCloseEditWindow': '編集した内容は保存されません。編集画面を閉じてよろしいですか？',
    'closeEditWindow': '編集画面を閉じる',
    '103': 'サービス権限の一括変更完了',
    '104': '{0}の権限の一括変更が完了しました。',
    '105':
      '一覧に表示中のユーザーのサービス権限を一括で変更できます。\n対象のユーザーを絞り込むには、ユーザー一覧にて検索を行ってください。',
    '106':
      'こちらの申請画面から企業管理者の最初の1名を申請することができます。\n（Buildee上に個人事業主として登録されている協力会社からは申請できません）\n\n企業管理者は自社ユーザーが利用するBuildeeサービスを設定することができます。また自社ユーザーに対して企業管理者権限を設定することができます。\n協力会社の企業管理者は、会社情報に支店を追加して、ユーザー・作業員を配属することができます。\n\n申請結果はBuildee上の通知、およびメールでお知らせいたします。\n申請結果が出るまでは5営業日ほどかかる場合があります。',
    '107': '出力中です。しばらくお待ちください...',
    '108': '10MB以下のJPEG、PNG、PDFファイルをアップロードしてください。',
    '109': '企業管理者申請',
    '110':
      '下記の注意事項をご確認のうえ「内容を確認して申請する」ボタンを押してください。\n\n・企業管理者の登録後に追加登録されたユーザーは、初期設定ではBuildee労務安全の利用ができません。\n　Buildee労務安全を利用する場合は設定を変更してください。\n・もし不必要な企業管理者が設定されている場合は、自社で設定を変更していただくか、当社までご連絡ください。',
    '111':
      '企業管理者は他のユーザーに対してサービス利用権限の付与・制限を行うことができます。',
    '112': '新規現場登録完了',
    '113': '新規現場の登録が完了しました。',
    '114': '現場更新完了',
    '115': '現場の更新が完了しました。',
    '116': '現場申請完了',
    '117': '現場の申請が完了しました。',
    '118': '現場申請更新完了',
    '119': '現場申請の更新が完了しました。',
    '120': '確認のうえ申請画面へ',
    '121': '協力会社の重複',
    '122': '追加する',
    '123': 'やめる',
    '124': '{0}ユーザーを企業管理者に設定することができます。',
    '125':
      'ログイン中のユーザーは企業管理者ではありません。企業管理者ユーザーでログインし、権限の変更を行ってください。',
    '126': '{0}ユーザーは権限を昇格させることができません。',
    '127':
      '企業管理者が1人もいない場合には、「ユーザー一覧」の「企業管理者申請」から企業管理者の申請を行うことができます。\nすでに企業管理者がいる場合には、企業管理者ユーザーが設定することができます。',
    '128': '利用者登録完了',
    '129': '利用者の登録が完了しました。',
    '130': '利用者更新完了',
    '131': '利用者の更新が完了しました。',
    '132':
      '該当するデータがありませんでした。条件を緩めて再度検索してください。\n\n＜法人の会社を検索する場合＞\nBuildeeには国税庁に登録されているすべての法人が表示されます。\n同名他社を誤って選択しないように法人番号での検索を推奨しております。\n\n＜個人事業主を検索する場合＞\n対象の個人事業主の方にBuildeeを利用したことがあるかご確認ください。\n利用したことがない場合、画面右下の「一覧にない個人事業主を新規登録」から登録をおこなえます。\nすでに登録があるにもかかわらず新規登録してしまうと、同じ個人事業主が複数登録されてしまい利用に支障をきたす可能性があります。',
    '133': '登録済み協力会社',
    '134':
      '法人の会社やBuildeeのアカウントを持つ個人事業主を検索できます。\n会社名や名前などを検索条件に入力して、検索ボタンを押してください。',
    '135':
      '未加入（加入状況が無）の場合、添付書類には加入手続き中であることを証明する書類等を登録することができます。',
    '136':
      '{0}を現場体制に追加しました。\n\n続けて管理者・職長の招待を行ってください。協力会社の追加だけでは協力会社ユーザーは現場にアクセスできません。\n管理者・職長の招待はあとから行うことも可能です。',
    '137': 'このページを再読込します',
    '138': 'トップページへ移動',
    '139':
      'ブラウザの他のページ（タブ）でBuildeeを使用しているときは、トップページへ移動後、他のページ（タブ）での操作ができなくなりますのでご注意ください。',
    '140': '代行登録済み',
    '141':
      'この会社とはすでに代行関係にあります。\n代行担当者を追加する場合は、代行先一覧から行ってください。',
    '142': '在留カードの在留期間(満了日)を入力してください。',
    '143':
      '永住者の作業員の場合は、在留カードの在留期間(満了日)ではなく、有効期限日を入力してください。',
    '144':
      '高度専門職２号の作業員の場合は、在留カードの在留期間(満了日)ではなく、有効期限日を入力してください。',
    '145':
      '16歳未満の作業員の場合は、在留カードの在留期間(満了日)ではなく、有効期限日を入力してください。',
    '146': '※数字のみを入力してください。',
    '147': '修正',
    '148': 'この内容で登録',
    '149': '協力会社ユーザー新規作成',
    '150': '招待しようとしているユーザー',
    '151': 'さん はすでに以下の会社に所属しています。',
    '152': 'さんを追加で以下の会社へ招待しようとしています。',
    '153': 'このまま登録を進めて問題がないかご確認ください。',
    '154': 'この会社に登録',
    '155':
      '入力したメールアドレス宛に、パスワードが記載された招待メールを送信します。',
    '156': 'この内容で登録します。',
    '157': '登録先の会社、ユーザー情報に間違いがないかご確認ください。',
    '158':
      'お手元の証明書・免許証に記載された有効期限年月日と一致しているか必ずご確認ください。',
    '159':
      'CCUSに技能者登録している場合は、CCUS連携情報の登録・連携を行ってください。\nCCUS連携に成功するとCCUSに登録された職種・免許などの詳細情報を取得できるようになります。\nまた、Buildeeで記録した入退場実績をCCUSへ送信できるようになります。',
    '160':
      'CCUSに技能者登録している場合は、CCUS連携情報の登録・連携を行ってください。\nCCUS連携に成功するとBuildeeで記録した入退場実績をCCUSへ送信できるようになります。 \n※代行先のCCUSに登録された詳細情報はCCUSの制限により取得できません。',
    '161':
      '「CCUSから情報を取得」をクリックするとCCUSに登録された作業員の詳細情報を取得できます。 \n取得した情報をBuildeeに登録する場合は転記してください。取得操作だけではBuildeeに登録されませんのでご注意ください。',
    '162':
      '取得日時以降にCCUSで登録情報の変更をしている場合は、再度「CCUSから情報を取得」をクリックし最新の情報を取得してください。 \n取得した情報をBuildeeに登録する場合は転記してください。取得操作だけではBuildeeに登録されませんのでご注意ください。\n\n取得した転記前の作業員の詳細情報は、一定期間経過すると削除されます。削除された場合には再度取得操作を行ってください。',
    '163':
      '代行先のCCUSに登録された詳細情報はCCUSの制限により取得できません。\nBuildeeに直接入力を行ってください。',
    '164': '転記の確認',
    '165': '全て転記',
    '166':
      '編集中のページ内のCCUS入力情報（青字）をすべてBuildeeに転記します。 \n既にBuildeeに登録済みの情報がある場合は上書きされますので、登録状況をご確認のうえ転記してください。 \n一部の情報だけを転記をしたい場合は',
    '167':
      'をクリックすることで個別に転記することが可能です。 \n\nCCUS入力情報（青字）をすべて転記してよろしいですか？',
    '168': 'ダウンロードエラー',
    '169':
      '{0}件のエラーデータがあります。エラー箇所をExcel上で修正し、再度一括取り込み操作を行ってください。',
    '170':
      '上記の組み合わせは既に使用されています。\n入力内容に誤りが無いか今一度お確かめください。\nまた過去に会社登録をされた場合許可番号が重複している可能性があります。\n今回改めて協力会社としての登録をする場合、「このまま更新」ボタンをクリックして登録を完了してください。',
    '171': 'CCUS現場情報の削除確認',
    '172':
      'CCUS現場IDを削除すると就業履歴や施工体制情報をCCUSに送信できなくなります。\nCCUS現場IDを削除してもよろしいですか？',
    '173':
      'CCUS現場IDと取得したCCUS入力情報（青字）を削除します。\nCCUS現場情報を削除してもよろしいですか？',
    '174': '施工体制連携の開始確認',
    '175': '連携開始',
    '176': '取得した現場情報',
    '177': '取得を継続する',
    '178': 'キャンセル',
    '179': '連携を開始できません',
    '180': '再読み込み',
    '181': '画面遷移する',
    '182':
      '二次以下の協力会社のユーザーは下位協力会社にユーザーを新規作成する権限がありません。\n新規作成が必要な場合には、一次協力会社か元請会社のユーザーにご依頼ください。',
    '183': '新規作成する権限がありません',
    '184': '新規登録する権限がありません',
    '185':
      '二次以下の協力会社のユーザーは個人事業主を新規登録する権限がありません。\n新規登録が必要な場合には、一次協力会社か元請会社のユーザーにご依頼ください。',
    '186': '一人親方',
    '187': '入退場実績の実績未反映数量',
    '188': '丁目・番地',
    '189': 'その他1（丁目・番地など）',
    '190': '（例）港区赤坂',
    '191': '（例）１－２－３',
    '192': '（例）1-2-3',
    '193': '（例）ミナトクアカサカ',
    '194': '（例）1チョウメ2-3',
    '195': '画面を開けませんでした。',
    '196': '作業員 基本情報登録完了',
    '197': '作業員 基本情報の登録が完了しました。',
    '198': '作業員 基本情報更新完了',
    '199': '作業員 基本情報の更新が完了しました。',
    '200': 'CCUS連携に成功しました',
    '201':
      'CCUSから作業員の各種情報を取得する場合は、労務安全基本情報タブなどの編集画面で「CCUSから情報を取得」ボタンを押下し転記を行ってください。',
    '202': '※ 設定から 1 時間程度で位置プラスへ反映されます',
    '203': '連携設定状況',
    '204': '協力会社連携設定完了',
    '205': '協力会社連携設定の更新が完了しました。',
    '206': '編集',
    '207': '二次の連携状態を表示',
    '208': '現場詳細',
    '209': '編集をやめる',
    '210':
      '「CCUSから情報を取得」をクリックするとCCUSに登録された会社情報を取得できます。 \n取得した情報をBuildeeに登録する場合は転記してください。取得操作だけではBuildeeに登録されませんのでご注意ください。',
    '211': 'クリア',
    '212':
      '返却済み端末の電話番号を記載したEXCELファイルを選択してください。\n選択と同時に端末の削除を実行します。',
    '213': 'EXCELファイルに記載された端末の削除が完了しました。',
    '214': 'CCUSとの連携がとれませんでした。CCUS連携情報を確認してください。',
    '215': 'CCUSに登録された技能レベルと一致しています。',
    '216':
      'Buildeeに登録された技能レベルと、CCUSに登録されている技能レベルが一致しません。CCUSに登録された技能レベル情報をご確認の上、修正を行ってください。',
    '218':
      '更新時にCCUSに登録された技能レベルと一致しているかの確認を行います。ステータスと整合性確認日時はCCUSと連携済みの場合データ更新時に自動で切り替わります。',
    '219': '技能レベルが一致しません',
    '220':
      'Buildeeに登録された技能レベルと、CCUSに登録されている技能レベルが一致しません。\nCCUSに登録された技能レベル情報をご確認の上、修正を行ってください。',
    '221': 'ご確認ください',
    '222': '連携に失敗しました',
    '223': 'JPEG、GIF、PNGファイルをアップロードして下さい。',
    '224':
      '編集可能な項目は何も設定されませんので、「一覧表示設定」から編集可能な項目を設定してください。',
    '225': '現在、施工体制情報をCCUSに連携中です。しばらくお待ちください。',
    '226': '竣工予定日を過ぎているため、自動連携は行われません。',
    '227':
      '竣工予定日を過ぎているため、自動連携は行われません。\n施工体制情報は「今すぐCCUSに連携」クリック時にCCUSへ連携されます。',
    '228':
      '【自動連携ON】施工体制情報は毎日夜間（毎週木曜日20:00～翌7:00を除く）にCCUSへ連携されます。',
    '229': '【自動連携OFF】施工体制情報は、元請ユーザーの手動操作で連携されます。',
    '230':
      '【自動連携OFF】施工体制情報は、メインJVの元請ユーザーの手動操作で連携されます。',
    '231':
      '【自動連携ON】施工体制情報は毎日夜間（毎週木曜日20:00～翌7:00を除く）にCCUSへ連携されます。\nすぐにCCUSに連携する場合は、「今すぐCCUSに連携」をクリックしてください。',
    '232':
      '【自動連携OFF】施工体制情報は「今すぐCCUSに連携」クリック時にCCUSへ連携されます。\n夜間に施工体制情報を自動で連携する場合は、現場詳細から設定してください。',
    '233':
      '進捗・歩掛を利用される際は別途利用料が追加となります。料金につきましては、本社管理者または支店のご担当者までご確認ください。',
    '234': 'GENBATONと連携している現場のため、進捗歩掛を有効化することはできません。',
    '235':
      '取得日時以降にCCUSで登録情報の変更をしている場合は、再度「CCUSから情報を取得」をクリックし最新の情報を取得してください。 \n取得した情報をBuildeeに登録する場合は転記してください。取得操作だけではBuildeeに登録されませんのでご注意ください。\n\n取得した転記前の会社情報は、一定期間経過すると削除されます。削除された場合には再度取得操作を行ってください。',
    '236': 'JV構成会社',
    '237': 'スポンサー会社',
    '238': 'スポンサーJVがCCUSを退会しているため、施工体制を連携できません。',
    '239':
      'スポンサーJVがCCUSを退会しているため、CCUSに施工体制技能者情報を連携できません。',
    '240':
      'この協力会社はCCUSを退会しているため、CCUSに施工体制技能者情報を連携できません。',
    '241':
      'この協力会社はCCUSを退会しているため連携が停止されています。\nCCUSに再加入した場合、協力会社にて会社情報のCCUS連携情報を再加入情報に更新することで連携が再開されます。',
    '242': 'CCUSを退会しているため、\nCCUSに登録することができません。',
    '243': 'CCUSを退会しているため、\nCCUSから現場情報を取得することができません。',
    '244': 'CCUSを退会しているため、施工体制を連携できません。',
    '245': 'サブ会社',
    '246': '元請がCCUSを退会しているため、施工体制を連携できません。',
    '247': '元請がCCUSを退会しているため、CCUSに施工体制技能者情報を連携できません。',
    '248': '次へ',
    '249': '検索条件',
    '250': '検索条件クリア',
    '251': 'クリックしてコピー',
    '252': 'コピーしました',
    '253': 'QRコード出力中です。しばらくお待ちください...',
    '254': '停止',
    '255': 'CCUS事業者IDの削除',
    '256': 'CCUS事業者IDが削除できませんでした',
    '257':
      '代表者名が登録されていないため、CCUS事業者IDを削除することができません。\nCCUS事業者IDを削除する場合、以下の「代表者名を登録する」ボタンをクリックして代表者名を登録してください。',
    '258': '代表者名を登録する',
    '259':
      '連携ユーザーは１名以上設定する必要があります。\n連携ユーザーを登録してください。',
    '260':
      '連携ユーザーが１名も登録されていません。\nCCUSから事業者情報や技能者情報を取得するには連携ユーザーの設定が必要です。\n\n連携ユーザーを登録せずに更新しますか？',
    '261':
      '労務安全を利用される際は別途利用料が追加となります。料金につきましては、本社管理者または支店のご担当者までご確認ください。',
    '262':
      '労務安全単体利用の支店の現場ため、労務安全機能をOFFにすることはできません。',
    '263': '代行先のCCUS連携情報が登録されており、作業員のCCUS連携に成功している',
    '264': '登録データの確認',
    '265':
      '特定技能１号を在籍させる場合、認定を受けた業務区分を入力してください。',
    '266': '協力会社の確認',
    '267':
      '該当するデータがありませんでした。検索条件を緩めて再度検索してください。\nそれでも該当するデータがない場合、招待したい会社の方にBuildeeを利用したことがあるかご確認ください。\n\n＜招待したい会社がBuildeeを利用したことがある場合＞\nBuildeeに登録されたすべての法人と個人事業主が検索可能です。検索条件を緩めて再度検索してください。\n法人の場合、法人番号で検索いただくことを推奨しております。個人事業主の場合、登録内容をご確認のうえ再度検索してください。\n\n＜招待したい会社がBuildeeを一度も利用したことがない場合＞\n協力会社の新規登録が必要です。二次以下の方は新規登録することができません。\n元請または一次協力会社の方に登録をご依頼ください。',
    '164-01': '現場掲示板',
    '164-02': '現場名',
    '164-03': '新規作成',
    '164-04': 'タイトル',
    '164-05': '公開状況',
    '164-06': '公開日',
    '164-07': '重要なお知らせのみ表示',
    '164-08': '未読のみ表示',
    '164-09': '検索',
    '164-10': 'クリア',
    '164-11': '作成者',
    '164-12': 'すべて',
    '164-13': '下書き',
    '164-14': '公開中',
    '164-15': '公開停止中',
    '164-16': '公開予約',
    '164-17': '入力してください',
    '164-18': 'Buildee利用終了日をすぎた現場ではお知らせの新規作成ができません。',
    '165-01': 'お知らせの下書き保存',
    '165-02': 'お知らせの下書き保存が完了しました。',
    '165-03': '下書き保存に失敗しました',
    '165-04': 'お知らせの公開確認',
    '165-05':
      '今すぐお知らせが公開されます。公開時メール通知にチェックを入れている場合、翌日にメール通知されます。よろしいですか？',
    '165-06': 'お知らせの公開・予約が完了しました。',
    '165-07': 'お知らせの公開・予約',
    '165-08': '公開する',
    '165-09': 'お知らせの公開予約確認',
    '165-10':
      '公開日に未来の日付が設定されています。公開日になるまでお知らせは公開されません。公開時メール通知にチェックを入れている場合、公開日にメール通知されます。よろしいですか？',
    '165-11': '予約する',
    '165-12': '公開',
    '165-13': '下書き保存',
    '165-14': 'ここにタイトルを入力してください',
    '165-15': 'ここにお知らせ内容を入力してください',
    '165-16': '公開日を入力',
    '165-17': '必須',
    '165-18': '公開設定',
    '165-19': '公開日',
    '165-20': '公開先',
    '165-21': 'すべての協力会社',
    '165-22': '一次協力会社のみ',
    '165-23': '公開時メール通知',
    '165-24': '公開時にお知らせ内容をメールで通知する',
    '165-25': 'お知らせ内容',
    '165-26': 'タイトル',
    '165-27': '重要度',
    '165-28': '重要なお知らせ',
    '165-29': '内容',
    '165-30': '添付ファイル',
    '165-31': '添付ファイルを追加',
    '165-32': '・最大5MBのファイルを10個まで添付可能です。',
    '165-33':
      '・選択可能な形式はWord(doc,docx)、Excel(xls,xlsx)、PowerPoint(ppt,pptx)、PDF、各種画像ファイル(JPEG、PNG、GIFなど)です。',
    '165-34':
      '※チェックを入れると一覧画面で重要なお知らせであることを示すマークが付きます。また、重要なお知らせのみを絞り込み検索できます。',
    '165-35': '現場掲示板',
    '165-36': 'お知らせ新規作成',
    '166-01': 'お知らせ詳細',
    '166-02': '公開時にお知らせをメールで通知しない',
    '166-03': '履歴',
    '166-04': 'ステータス',
    '166-05': 'ユーザ名',
    '166-06': '日付',
    '166-07': '新規作成',
    '166-08': '最終更新',
    '166-09': '停止',
    '166-10': '再公開',
    '166-11': '-',
    '166-12': '編集',
    '166-13': '停止',
    '166-14': 'お知らせの公開停止確認',
    '166-15':
      'お知らせの公開を停止します。\n再度、公開できるのはお知らせを作成したユーザーのみになります。\n再度お知らせを公開する場合、一度既読にしたユーザーも未読状態になります。\nよろしいですか？',
    '166-16': 'お知らせの公開停止',
    '166-17': 'お知らせの公開を停止しました。',
    '166-18': '停止する',
    '166-19': '協力会社：',
    '166-20':
      '※お知らせは作成したユーザーのみが編集できます。お知らせの編集には停止が必要です。',
    '166-21': '元請会社：',
    '166-22': '現場名：',
    '166-23': '作成日：',
    '166-24': '作成者：',
    '166-25': '最終更新日：',
    '166-26': '最終更新者：',
    '166-27': '公開日：',
    '167-01': '更新',
    '167-02': 'お知らせの更新',
    '167-03': 'お知らせの更新が完了しました',
    '167-04': 'お知らせ編集',
    '167-05': '削除',
    '167-06': 'お知らせの削除',
    '167-07': 'お知らせの削除が完了しました',
    '167-08': 'お知らせの削除確認',
    '167-09':
      'お知らせを削除すると閲覧できなくなります。\nまた、この操作は取り消せません。\nよろしいですか？',
    '167-10': '削除する',
    '167-11': 'お知らせの更新確認',
    '167-12': 'お知らせの内容を更新します。よろしいですか？',
    '167-13': '更新する',
  },
  W: {
    '001':
      '選択中の入退場機器はすでに現場に割り当てられています。\n本当に削除してもよろしいですか？\n割り当ても自動的に解除されます。',
    '002':
      '選択中の入退場機器はすでに現場に割り当てられています。\n本当に更新してもよろしいですか？\n割り当ても自動的に更新されます。',
    '003': 'データを削除します。この作業は取り消せません。',
    '004':
      'すでに現場体制に存在する協力会社です。この協力会社をもう一度追加してよろしいですか？',
    '005':
      '現場から削除した協力会社のユーザーはこの現場にアクセスできなくなります。\nこの操作は取り消せません。\n本当に削除しますか？',
    '006':
      'この協力会社および下位協力会社が作成または提出している労務安全書類があります。\nこの操作を行った場合、当該労務安全書類はすべて破棄されます。\n本当に削除しますか？',
    '007': '有効期限が{0}を切っています。',
    '008':
      '有効期限が{0}を切っています。{1}の更新を行っている場合、{2}の更新をしてください。',
    '009': '有効期限が切れています。',
    '010':
      '有効期限が切れています。{0}の更新を行っている場合、{1}の更新をしてください。',
    '011': '有効期限年月日が取得年月日より前の日付になっています。',
    '012':
      '前回の受診から{0}以上が経過しています。健康診断を行い、受診日の更新をしてください。',
    '013':
      'まもなく前回の受診から{0}が経過します。改めて受診した後、受診日を更新してください。',
    '014': '期限切れ',
    '015': '期限切れ間近',
    '016':
      '選択された{0}を削除します。本当によろしいですか？\n{0}予定で使用されている{0}は削除できません。',
    '017': 'BuildeeとCCUSの技能レベルに不整合があります。',
    '018': '技能レベルが未確認です。',
    '019':
      '※健康診断の実施頻度が適切ではない場合には、「受診頻度」を変更してください。',
    '020':
      '選択された種別に同名のファイルが添付されています。\nこのまま更新すると、ファイルは新しいものに上書きされます。\n\n更新してよろしいですか？',
    '021':
      '着工日が変更されました。\n変更後の日付から入退場実績をCCUSに送信する場合には、CCUSの管理画面にて「就業履歴蓄積期間_開始日」を変更する必要があります。\nBuildeeの着工日を変更しても、CCUSに自動的には反映されませんのでご注意ください。',
    '022':
      '竣工予定日が変更されました。\n変更後の日付まで入退場実績をCCUSに送信する場合には、CCUSの管理画面にて「就業履歴蓄積期間_終了日」を変更する必要があります。\nBuildeeの竣工予定日を変更しても、CCUSに自動的には反映されませんのでご注意ください。',
    '023':
      '「着工日」と「竣工予定日」が変更されました。\n変更後の期間に入退場実績をCCUSに送信する場合には、CCUSの管理画面にて「就業履歴蓄積期間」を変更する必要があります。\nBuildeeの着工日や竣工予定日を変更しても、CCUSに自動的には反映されませんのでご注意ください。',
    '024':
      'が変更されています。\n変更後の日付まで入退場実績をCCUSに送信する場合には、CCUSの管理画面から「就業履歴蓄積期間_終了日」を変更する必要があります。\nBuildeeの竣工予定日を変更しても、CCUSに自動的には反映されませんのでご注意ください。',
    '025':
      'が変更されています。\n変更後の日付から入退場実績をCCUSに送信する場合には、CCUSの管理画面から「就業履歴蓄積期間_開始日」を変更する必要があります。\nBuildeeの着工日を変更しても、CCUSに自動的には反映されませんのでご注意ください。',
    '026': '※各種免許証・顔写真は添付しないでください。',
    '027': '＜名刺画像アップロード時の注意事項＞',
    '028':
      '業務区分には「土木」「建築」「ライフライン・設備」のいずれかの文言を含めてください。',
    '029':
      '「特定技能制度に関する下請指導ガイドライン」の改訂に伴い入力が不要な項目になりました。\n更新を行うとこの項目は削除され表示されなくなります。',
  },
  E: {
    '001': '通信エラーです。',
    '002': 'ユーザーIDを更新できませんでした。',
    '003': '画像エラー',
    '004': 'パスワードを更新できませんでした',
    '005': '更新に失敗しました。',
    '006': '登録に失敗しました。',
    '007': 'エラー：{0}',
    '008': '必須です。１つ以上の時間帯を使用するようにしてください。',
    '009': '前の適用開始日より後の日付にしてください。',
    '010': '必須です。',
    '011':
      'ファイルアップロードの上限は15MBです。\n15MB以下の画像を選択してください。',
    '012': '選択可能な画像形式は「JPEG、GIF、PNG」ファイルです。',
    '013': '前回データが存在しません。',
    '014': '入力エラーがあります。',
    '015': '着工日は竣工予定日以前の日付を入力してください。',
    '016': '値を選択してください。',
    '017': '半角数字を入力してください。',
    '018': '{0}日以下で入力して下さい。',
    '019': '同じ支店は選択できません。',
    '020': '登録されました。',
    '021': 'エラーです。',
    '022': '10MB以下の画像を選択してください。',
    '023': '必須です。{0}を選択してください。',
    '024': '必須です。{0}文字以下で入力してください。',
    '025': '必須です。{0}文字以下のひらがなで入力してください。',
    '026': '{0}文字以下で入力してください。',
    '027': '必須です。{0}～{1}の半角数字を入力してください。',
    '028': '必須です。{0}文字以下の半角英数字で入力してください。',
    '029': '選択可能な画像形式は「{0}」ファイルです。',
    '030':
      '選択した法人の法人番号のデータが既に登録されていました。法人選択からやりなおしてください。',
    '031':
      '選択した個人のデータが既に登録されていました。個人選択からやりなおしてください。',
    '032': '失敗しました。',
    '033': '現在このマニュアルをダウンロードすることができません。',
    '034': '{0}の承認に失敗しました。',
    '035': '１つ以上の作業場所項目を使用するようにして下さい',
    '036': '予期せぬエラーです。',
    '037': '未契約のため閲覧権限がありません。',
    '038': '選択可能なファイル形式は「{0}」ファイルです。',
    '039': '終了日は開始日と同じか以降の日を指定してください。',
    '040': '数値で入力してください。',
    '041': '半角数字とピリオド（.）で入力してください。',
    '042': '半角数字と半角記号で入力してください。',
    '043': '半角英数字と半角記号で入力してください。',
    '044':
      'ファイルアップロードの上限は15MBです。\n15MB以下のファイルを選択してください。',
    '045': '選択可能なファイル形式は「PDF、JPEG、GIF、PNG」です。',
    '046':
      'ファイルアップロードの上限は{0}MBです。\n{0}MB以下のファイルを選択してください。',
    '047': 'ユーザーを選択してください。',
    '048':
      'アップロード可能なファイルの上限は{0}MBです。\n{0}MB以下のファイルを選択してください。',
    '049':
      'アップロード可能なファイル名の上限250文字です。ファイル名が250文字以下のファイルを選択してください。',
    '050':
      '処理中の申請があります。前回申請分の処理が完了するまでは、次の申請をすることができません。',
    '051': '通信エラーが発生しました。電波の良いところで再度お試しください。',
    '052':
      '多重送信を検知したため、2回目以降の処理を止めました。登録内容が反映されているかご確認ください。',
    '053': '多重送信を検知しました',
    '054': '選択した協力会社はすでに協力会社一覧に登録済みです。',
    '055':
      'エラーが発生しました。しばらく時間をおいてから再度操作を行ってください。\n再度操作してもエラーが解消しない場合、システム管理者までお問い合わせください。',
    '056': '現在利用料金表をダウンロードすることができません。',
    '057': 'このURLは有効期限が切れているため使用できません。',
    '058':
      'このリンクは現在有効ではありません。トップページから操作しなおしてください。',
    '059': '選択可能なファイル形式は「xlsx」ファイルです。',
    '060':
      'ファイルアップロードの上限は15MBです。\n15MB以上になる場合にはファイルを分割し複数回にわけて一括登録してください。',
    '061':
      '作業場所の組み合わせ上限（{0}件）を超過しました。\n{1}の作業場所組み合わせ件数が{0}件以下となるように設定してください。',
    '062':
      '他ユーザーにより登録内容が変更されました。\n画面を再読み込みしてください。',
    '063': '操作権限がありません',
    '064':
      '他社の元請BOXに管理者・現場監督を招待することはできません。\n該当元請のユーザーに操作をご依頼ください。',
    '065':
      '元請BOXに管理者・現場監督を招待する権限がありません。\n自身が所属している支店か、自身が招待されている元請BOXしか操作を行うことができません。',
    '066':
      '元請BOXに管理者・現場監督を招待する権限がありません。\n自身が招待されている元請BOXしか操作を行うことができません。',
    '067': '必須項目の入力が足りていないため、送信できません。',
    '068': '地域のバリエーションエラーが発生されています。',
    '069': '協力会社連携設定エラー',
    '070': 'エラーが発生しました。もう一度実行するか、後ほどお試しください。',
    '071':
      '「現場入場時点で６０歳以上で厚生年金保険に未加入」は利用できなくなりました、他の理由を選択してください。',
    '072':
      'GENBATONと連携されている現場のため、進捗歩掛を有効化することはできません。画面を再読み込みしてください。',
    '073':
      '工種が存在しません。他のユーザーが更新した可能があります。画面を更新してご確認ください。',
    '074':
      'このURLは有効期限が切れている、もしくは存在しないURLなため使用できません。',
    '075': '対象の施工体制が削除されたため、操作を完了できませんでした。',
    '076': '操作を完了できませんでした。',
    '077': '現場更新失敗',
    '078':
      '労務安全単体利用の支店の現場ため、労務安全機能をOFFにすることはできません。\n労務安全機能をONに変更して更新してください。',
    '079': '有効期限が間違っています。\n正しい情報を入力してください。',
    '080': '従事開始年月日は従事終了年月日より過去の日付を設定してください。',
    '081': '従事終了年月日は従事開始年月日より未来の日付を設定してください。',
    '082':
      'CCUSからの情報取得に失敗しました。\n他のユーザーの操作によって、連携に必要な条件を満たさなくなりました。\nこのメッセージを閉じると画面が更新され、連携に必要な条件が表示されます。',
    '001-01': '不正なメーカーIDです。',
    '001-02': '不正な機種IDです。',
    '001-03': 'この入退場機器IDはすでに存在します。',
    '001-04': '入力された入退場機器名はすでに登録されています。',
    '001-05': '対象のデータが存在しません',
    '001-06': '対象のデータは削除できません',
    '001-07': '対象のデータはすでに登録されています',
    '001-08': '機種が登録されていません',
    '002-01': '指定した入退場記録は存在しません。',
    '002-02': '指定した現場ツリーIDは不正です。',
    '002-03': '入退場記録の更新に失敗しました。',
    '002-04': '入退場記録の削除に失敗しました。',
    '002-05': 'workerの現場IDとfield_tree_workersの現場IDが一致しません',
    '003-01': '対象のデータが存在しません。',
    '003-02': '対象のメーカーデータが存在しません。',
    '003-03': '対象の入退場機器モデルが存在しません。',
    '003-04': '指定した入退場機器IDはすでに使われています。',
    '003-05': '指定した入退場機器名はすでに使われています。',
    '004-01': '対象のデータが存在しません。',
    '004-02': '対象のデータは削除できません。',
    '005-01': '確認',
    '005-02':
      '現在、デモ版のBuildeeをご利用頂いています。\nデモ版ではヘルプセンターをご利用いただくことができません。\n\n操作についてご不明な点がございましたらカスタマーサポートまでお問い合わせください。\n※お問い合わせ時にはデモ版をご利用いただいていることをお伝えください。\n\n■Buildee カスタマーサポート窓口\n電話番号：0120-305-878\nメール：bld-support@buildee.jp\n営業時間：9:15〜17:30（土・日・祝日および弊社休業日を除く）\n\nメールでお問い合わせいただいた場合、回答まで半日～３営業日程度のお時間をいただきます。\nお問い合わせ内容や混雑具合によっては回答までに3営業日以上お時間を頂戴する場合がございます。\nお問い合わせ内容確認のため、お電話をさせていただくことがございます。\n\n正確な対応のため、メールには以下の内容をご記入ください。\n\nご利用の環境：デモ\n会社名：\nお名前：\nお客様番号：（画面左の黒いメニュー下部に表示）\n電話番号：\n現場名：\n問い合わせ内容：（画面、対象データの日付や会社名、ご利用のブラウザなどの情報を詳細にご記入ください）',
    '201-01':
      'ファイルアップロードの上限は10MBです。\n10MB以下の画像を選択してください。',
    '201-02': '選択可能な画像形式は「JPEG」ファイルです。',
    '201-03': '画像サイズが小さすぎます。300×300px 以上の画像を選択してください。',
    '201-04':
      '切り抜き後の画像サイズが小さすぎます。切り抜き範囲を広げるか、より大きなサイズの画像ファイルを選択してください。',
    '164-01': '公開日は現在と同じ日付か未来の日付を指定してください。',
    '165-01':
      'ファイルアップロードの上限ファイル数は10ファイルです。これ以上アップロードできません。',
    '165-02':
      'ファイルアップロードの上限サイズは5MBです。5MB以下のファイルを選択してください。',
    '165-03':
      '選択可能なファイル形式は「doc(docx),xls(xlsx),jpg,jpeg,png,bmp,tiff,tif,gif,pdf,ppt(pptx)」ファイルです。',
    '165-04': '公開・予約に失敗しました',
    '167-01': '更新に失敗しました',
    '167-02': '削除に失敗しました',
    '167-03':
      '公開日にBuildee利用終了日（{0}）よりも後の日付が入力されています。Buildee利用終了日より前の日付を入力してください。',
    '166-01': '公開停止に失敗しました',
    '166-02': 'エラーが発生しました。再度操作を行ってください。',
    '166-03': '公開停止に失敗しました',
    '166-04':
      '他のユーザーが更新した可能性があります。画面を更新してご確認ください。',
    '166-05': 'ファイルのダウンロードに失敗しました。画面を更新してご確認ください。',
  },
};



// WEBPACK FOOTER //
// ./src/utilities/messages/common.js